import { render, staticRenderFns } from "./BoxContactPage.vue?vue&type=template&id=3486ee68&"
import script from "./BoxContactPage.vue?vue&type=script&lang=js&"
export * from "./BoxContactPage.vue?vue&type=script&lang=js&"
import style0 from "./BoxContactPage.vue?vue&type=style&index=0&id=3486ee68&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QIcon,QForm,QInput,QBtn,QInnerLoading,QSpinnerTail} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QIcon,QForm,QInput,QBtn,QInnerLoading,QSpinnerTail})
